import { render, staticRenderFns } from "./InsularTables.vue?vue&type=template&id=b499e490&"
import script from "./InsularTables.vue?vue&type=script&lang=js&"
export * from "./InsularTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports